import { render, staticRenderFns } from "./BackRow.vue?vue&type=template&id=d47a0e26&scoped=true&"
import script from "./BackRow.vue?vue&type=script&lang=js&"
export * from "./BackRow.vue?vue&type=script&lang=js&"
import style0 from "./BackRow.vue?vue&type=style&index=0&id=d47a0e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47a0e26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
